module.exports = __webpack_public_path__ + "static/img/sence2.4c17edf.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/media5/sence2.png
// module id = POYM
// module chunks = 7